// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"styles_modalWrapper__JMYYc","modal":"styles_modal__23T7B"};